module.exports = __webpack_public_path__ + "img/card_2_ref_1.df09e623.jpg";